import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    constructor(private _httpClient: HttpClient) {}

    // Setter & getter for user
    set user(value: User) {
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    /**
     * Get the current logged in user data (dari localStorage)
     */
    get(): Observable<User> {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            const user: User = JSON.parse(userStr);
            this._user.next(user);
            return new Observable((observer) => {
                observer.next(user);
                observer.complete();
            });
        }

        // fallback kalau kosong → hit API
        return this._httpClient.get<User>('api/common/user').pipe(
            tap((user) => {
                this._user.next(user);
                localStorage.setItem('user', JSON.stringify(user));
            })
        );
    }

    /**
     * Update the user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>('api/common/user', { user }).pipe(
            map((response) => {
                this._user.next(response);
                localStorage.setItem('user', JSON.stringify(response));
            })
        );
    }
}
